import React from "react"
import PropTypes from "prop-types"

import { navigate } from "gatsby"

import ReactModal from "react-modal"

import ComponentFactory from "../parsers/ComponentFactory"

import * as modalStyles from "../../styles/Modal.module.css"

const modalPage = (repo, url) => {
  const indexedRepo =
    repo &&
    repo.nodes &&
    repo.nodes.reduce((prev, curr) => {
      prev[curr.slug] = curr
      return prev
    }, {})

  return (indexedRepo && indexedRepo[url.replace(/\//g, ``)]) || null
}

function Modal(props) {
  const [showModal, setShowModal] = React.useState(false)

  const handleOpenModal = () => {
    const page = modalPage(props.modalsRepo, props.url)

    if (page) setShowModal(true)
    if (!page) navigate(props.url)
  }
  const handleCloseModal = () => setShowModal(false)

  ReactModal.setAppElement("#___gatsby")

  const page = modalPage(props.modalsRepo, props.url)

  const pageContentWrapperProps = {
    className: `talk-to-us`,
  }
  const pageComponents =
    page && ComponentFactory(page.content, pageContentWrapperProps)

  return (
    <>
      {props.children({ handleOpenModal })}
      <ReactModal
        isOpen={showModal}
        className={`container-fluid brand-${props.brand} ${modalStyles.wrapper}`}
        style={{
          overlay: {
            zIndex: 100000,
            backgroundColor: `rgba(0,0,0,0.6)`,
          },
          content: {},
        }}
        contentLabel="Contact us"
      >
        <div className={modalStyles.externalHolder}>
          <button
            className={modalStyles.closeButton}
            onClick={handleCloseModal}
          >
            X
          </button>
          <div
            className={`container-fluid ${modalStyles.innerWrapper}`}
            style={{
              height: "auto",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="row">
              <div className="col-12">{pageComponents}</div>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  )
}

Modal.propTypes = {
  url: PropTypes.string.isRequired,
  modalsRepo: PropTypes.object.isRequired,
}

export default Modal
